import { Box, Fade, Tooltip, Typography, useTheme } from '@mui/material'
import { tableScreenStyles } from '../../../../../shared/styles/TableScreenStyles'

interface CustomEmailCellProps {
  email: string
}

const CustomEmailCell = ({ email }: CustomEmailCellProps) => {
  const theme = useTheme()
  const tableClass = tableScreenStyles(theme)

  return (
    <Box display="flex" alignItems="center" gap={8}>
      <Tooltip placement="bottom-start" TransitionComponent={Fade} TransitionProps={{ timeout: 400 }} title={email}>
        <Typography sx={tableClass.emailText}>{email}</Typography>
      </Tooltip>
    </Box>
  )
}

export default CustomEmailCell
